import * as THREE from 'three';
import vertexShader from '../shaders/grass.vertex.glsl';
import fragmentShader from '../shaders/grass.fragment.glsl';

class Grass {
  sideLength = 100;
  grassWidth = 0.1;
  instance = (100/ this.grassWidth) * (100/this.grassWidth);
  colorOne = '#455B0A';
  colorTwo = '#847e06';
  lightIntensity = 2.5;
  heightScale = 3.5;

  textureLoader = new THREE.TextureLoader();

  positions = [];
  indexs = [];
  uvs = [];
  
  aRandoms = [];
  aPositions = [];

  constructor(props) {
    this.sideLength = props.sideLength;
    this.instance = (this.sideLength/this.grassWidth) * (this.sideLength/this.grassWidth);
    this.colorOne = props.colorOne;
    this.colorTwo = props.colorTwo;
    this.lightIntensity = props.lightIntensity;
    this.heightScale = props.heightScale;
  }


  init() {
    this.generateGrassPosition();

    this.geometry = new THREE.InstancedBufferGeometry();
    console.log(this.instance);
    this.geometry.instanceCount = this.instance;

    this.geometry.setAttribute('position', new THREE.Float32BufferAttribute(this.positions, 3));
    this.geometry.setAttribute('uv', new THREE.Float32BufferAttribute(this.uvs, 2));
    this.geometry.setAttribute('aPositions', new THREE.InstancedBufferAttribute(new Float32Array(this.aPositions), 3));
    this.geometry.setAttribute('aRandoms', new THREE.InstancedBufferAttribute(new Float32Array(this.aRandoms), 1));
    this.geometry.setIndex(new THREE.Uint16BufferAttribute(this.indexs, 1));

    this.geometry.computeVertexNormals();
    this.geometry.attributes.uv.needsUpdate = true;
    this.geometry.attributes.position.needsUpdate = true;
    this.geometry.attributes.aPositions.needsUpdate = true;
    this.geometry.attributes.aRandoms.needsUpdate = true;

    const perlinTexture = this.textureLoader.load('./perlin.png'); 
    perlinTexture.wrapS = perlinTexture.wrapT = THREE.RepeatWrapping;


    this.material = new THREE.ShaderMaterial({
      transparent: true,
      vertexShader,
      fragmentShader,
      uniforms: {
        uTime: new THREE.Uniform(0),
        uHeightMap: new THREE.Uniform(this.textureLoader.load('./heightMap.png')),
        uPerlin: new THREE.Uniform(perlinTexture),
        uCameraPosition: new THREE.Uniform(new THREE.Vector3(0.0)),

        uSideLength: new THREE.Uniform(this.sideLength),
        uHeightScale: new THREE.Uniform(this.heightScale),
        uColorOne: new THREE.Uniform(new THREE.Color(this.colorOne)),
        uColorTwo: new THREE.Uniform(new THREE.Color(this.colorTwo)),
        uLightIntensity: new THREE.Uniform(this.lightIntensity),
      }
    });

    return new THREE.Mesh(this.geometry, this.material);

  }

  generateGrassPosition() {
    this.positions.push(-this.grassWidth, 0, 0);
    this.positions.push(this.grassWidth, 0, 0);
    this.positions.push(0, 1, 0);

    this.indexs.push(0, 1, 2);
    
    this.uvs.push(0, 0);
    this.uvs.push(1, 0);
    this.uvs.push(1, 1);


    let posX = -this.sideLength / 2;
    let posZ = -this.sideLength / 2;

    for (let i = 0; i < this.instance; i++) {

      this.aPositions.push(posX);
      this.aPositions.push(0);
      this.aPositions.push(posZ);

      posX += this.grassWidth;

      if(posX >= this.sideLength / 2) {
        posX = -this.sideLength / 2;
        posZ += this.grassWidth;
      }

      this.aRandoms.push(Math.random());

    }
  }
  


  update(time, cameraPos) {
    this.material.uniforms.uTime.value = time;
    this.material.uniforms.uCameraPosition.value = cameraPos;
  }

}


export default Grass;
